import environment from '@/modules/cart/environments/environment';

import type { PriceDto } from '../types/PriceDto';

const { LOCALE } = environment;

export const formatPriceString = (price: number): string =>
  new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'CLP'
  }).format(price);

export const priceDtoToPriceString = (priceDto: PriceDto): string =>
  new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: priceDto.currencyCode
  }).format(priceDto.centAmount);

export const discountToPercentage = (discount: number): string => {
  const percent = Math.floor(discount * 100);
  return `${percent}%`;
};
